export default {
    api: {
        URL: '/api'
    }
};